/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagDto } from '../../models/tag-dto';

export interface TagControllerConnectTagToChilds$Params {
  tagId: string;
  centerChildIds: Array<string>;
  centerId: string;
}

export function tagControllerConnectTagToChilds(http: HttpClient, rootUrl: string, params: TagControllerConnectTagToChilds$Params, context?: HttpContext): Observable<StrictHttpResponse<TagDto>> {
  const rb = new RequestBuilder(rootUrl, tagControllerConnectTagToChilds.PATH, 'patch');
  if (params) {
    rb.query('tagId', params.tagId, {});
    rb.query('centerChildIds', params.centerChildIds, {});
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagDto>;
    })
  );
}

tagControllerConnectTagToChilds.PATH = '/api/tag/connect';
